import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const MicDisabled = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 21V19M12 19C8.32179 19 6.14683 16.7451 5.01434 15M12 19C14.2282 19 15.9048 18.1725 17.1321 17.1321M9.51896 3.86222C10.2008 3.32235 11.0628 3 12 3C14.2092 3 16 4.79086 16 7V10.3433M3 3L8.00001 8.00001M8.00001 8.00001V11C8.00001 13.2091 9.79087 15 12 15C12.8492 15 13.6365 14.7354 14.2841 14.2841M8.00001 8.00001L14.2841 14.2841M14.2841 14.2841L17.1321 17.1321M17.1321 17.1321L21 21'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M12 2.25C10.8878 2.25 9.86295 2.6332 9.05335 3.27422C8.88558 3.40706 8.78255 3.60523 8.77018 3.81886C8.7578 4.0325 8.83728 4.24124 8.98859 4.39255L15.4696 10.8736C15.6841 11.0881 16.0067 11.1523 16.287 11.0362C16.5672 10.9201 16.75 10.6466 16.75 10.3433V7C16.75 4.37665 14.6233 2.25 12 2.25Z'
          fill='currentColor'
        />
        <path
          d='M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L7.25001 8.31067V11C7.25001 13.6234 9.37666 15.75 12 15.75C12.7798 15.75 13.517 15.5616 14.1671 15.2278L15.9947 17.0554C14.9636 17.752 13.6536 18.25 12 18.25C8.68038 18.25 6.70631 16.2295 5.64348 14.5917C5.418 14.2443 4.95353 14.1454 4.60607 14.3709C4.25861 14.5963 4.15972 15.0608 4.38521 15.4083C5.51091 17.1429 7.66582 19.436 11.25 19.7206V21C11.25 21.4142 11.5858 21.75 12 21.75C12.4142 21.75 12.75 21.4142 12.75 21V19.7205C14.5169 19.5796 15.9445 18.9486 17.0716 18.1322L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L3.53033 2.46967Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
